import {PinData, PinLocation} from "../../../model2/pin/@types"

export default async function toggleItemPin(data: PinData, callback?: callback) {
    let isPinned = !!gd.session.pins.getPinId(data)

    if (!isPinned) {
        await pinItem(data, callback)
    } else {
        await unPinItem(data, callback)
    }

    return isPinned
}

export async function pinItem(data: PinData, callback?: callback) {
    let isPinned

    try {
        await gd.api.Pins.addPin(data).promise()
        isPinned = true
        callback && callback(isPinned)
    } catch (e) {
        isPinned = false
        console.error('toggleItemPin pin error:', e)
    }

    return isPinned
}

export async function unPinItem(data: PinData, callback?: callback) {
    let isPinned

    // Delete favorite
    const pinId = gd.session.pins.getPinId(data)

    if (pinId) {
        try {
            gd.session.pins.remove(pinId)
            await gd.api.Pins.removePin(pinId).promise()
            isPinned = false
            callback && callback(isPinned)
        } catch (e) {
            isPinned = true
            console.error('toggleItemPin unpin error:', e)
        }
    }

    return isPinned
}

export async function updatePinItemLocation(data: PinData, location: PinLocation, callback?: callback) {
    const pinId = gd.session.pins.getPinId(data)

    let success
    if (pinId) {
        try {
            await gd.api.Pins.updatePin(pinId, location).promise()
            success = true
        } catch (e) {
            success = false
            console.error('updatePinItemLocation error:', e)
        }
    }

    return success
}